<nav>
  <div class="nav-links">
    <a *ngIf="canImportData" routerLink="/home/upload" routerLinkActive="active" class="nav-link">
      <lucide-angular name="upload" class="icon"></lucide-angular>
      <span class="nav-text">{{ "navigation.uploadData.text" | translate }}</span>
    </a>
    <a routerLink="/home/samples" routerLinkActive="active" class="nav-link">
      <lucide-angular name="fileText" class="icon"></lucide-angular>
      <span class="nav-text">{{ "navigation.samples.text" | translate }}</span>
    </a>
    <a *ngIf="isMetadataPage" routerLink="./" routerLinkActive="active" class="nav-link">
      <lucide-angular name="user" class="icon"></lucide-angular>
      <span class="nav-text">{{ "navigation.patientMetadata.text" | translate }}</span>
    </a>
    <a *ngIf="canOpenGrafana" role="button" tabindex="0" class="nav-link" (click)="openGrafana()" (keydown.enter)="openGrafana()">
      <lucide-angular name="chartColumn" class="icon"></lucide-angular>
      <span class="nav-text"
        >{{ "navigation.analytics.text" | translate }}
        <lucide-angular name="externalLink" class="external-icon" [size]="14" aria-hidden="true"></lucide-angular
      ></span>
    </a>
    <a *ngIf="canAccessAdministration" routerLink="/administration" routerLinkActive="active" class="nav-link">
      <lucide-angular name="settings" class="icon"></lucide-angular>
      <span class="nav-text">{{
        (canViewAllOrganizations ? "navigation.administration.superAdmin.title" : "navigation.administration.admin.title") | translate
      }}</span>
    </a>
  </div>
</nav>
